import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function Level3Illustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3945" data-mp="16ohu9eo82v60">
      <div className="relative w-full h-full bg-gradient-to-b from-lime-100 to-green-300 overflow-hidden" data-id="element-3946" data-mp="11nlkikh6weso">
        {/* Background: Sprout hill */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3947" data-mp="sqb4ymxca3hy">
          <circle cx="160" cy="40" r="22" fill="#FEF08A" data-id="element-3948" data-mp="2n3su2ede78f3" />
          <path d="M0 165 Q100 130 200 165 L200 200 L0 200 Z" fill="#4ADE80" data-id="element-3949" data-mp="2n16nagybswxx" />
          {/* Small sprout */}
          <path d="M100 165 L100 140" stroke="#16A34A" strokeWidth="3" strokeLinecap="round" data-id="element-3950" data-mp="2i2d7uizhavv4" />
          <path d="M100 150 Q88 142 84 150 Q92 156 100 150 Z" fill="#22C55E" data-id="element-3951" data-mp="1vjcg7vwo03yt" />
          <path d="M100 145 Q112 137 116 145 Q108 151 100 145 Z" fill="#22C55E" data-id="element-3952" data-mp="1hjl6i7d6l9qm" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[6%]" data-id="element-3953" data-mp="1mjz4sxozd5bg">
          <div className="w-[60%] h-[60%] flex items-center justify-center" data-id="element-3954" data-mp="2a88uiapbed7v">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'happy' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3955" data-mp="2f58srzfxabof" />
          </div>
        </div>

        {/* Foreground: level badge */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3956" data-mp="2xxjrri7ghph9">
            <circle cx="40" cy="40" r="18" fill="#16A34A" data-id="element-3957" data-mp="32uyuvrztzxtq" />
            <text x="40" y="46" textAnchor="middle" fontFamily="sans-serif" fontSize="16" fontWeight="900" fill="white" data-id="element-3958" data-mp="2xuuc1vbgar0c">
              3
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}